
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M8.248 9.479v-.957a7.26 7.26 0 00-.98-.071c-4.004 0-7.261 3.257-7.261 7.26a7.255 7.255 0 003.098 5.945 7.213 7.213 0 01-1.926-4.944A7.227 7.227 0 018.248 9.48z","fill":"#25F4EE"}}),_c('path',{attrs:{"d":"M8.42 20.049c1.785 0 3.263-1.442 3.33-3.212l.015-15.786h2.862l-.004-.024A5.474 5.474 0 0114.53.026h-3.945l-.006 15.809a3.309 3.309 0 01-4.848 2.81c.603.837 1.582 1.404 2.688 1.404zM20.018 6.441v-.926a5.453 5.453 0 01-2.989-.888c.767.88 1.807 1.561 2.989 1.814z","fill":"#25F4EE"}}),_c('path',{attrs:{"d":"M17.03 4.627a5.462 5.462 0 01-1.35-3.598h-1.075c.278 1.502 1.188 2.791 2.424 3.598zM7.27 12.365c-1.829 0-3.339 1.518-3.339 3.346 0 1.273.745 2.38 1.8 2.935a3.31 3.31 0 012.688-5.25c.332.001.662.053.979.154V9.522a7.255 7.255 0 00-.979-.07c-.057 0-.114.003-.171.004h-.015l-.011 3.048a3.084 3.084 0 00-.953-.139z","fill":"#FE2C55"}}),_c('path',{attrs:{"d":"M20.018 6.392H20v3.046a9.415 9.415 0 01-5.493-1.783v8.058a7.232 7.232 0 01-7.238 7.239 7.217 7.217 0 01-4.16-1.294 7.242 7.242 0 005.31 2.317c4.004 0 7.26-3.258 7.26-7.261V8.696a9.381 9.381 0 005.489 1.764V6.516c-.387 0-.772-.042-1.15-.124z","fill":"#FE2C55"}}),_c('path',{attrs:{"d":"M14.53 15.711V7.695a9.38 9.38 0 005.49 1.765V6.392a5.49 5.49 0 01-2.99-1.765 5.498 5.498 0 01-2.407-3.598h-2.888l-.006 15.809a3.31 3.31 0 01-5.998 1.81 3.314 3.314 0 011.538-6.252c.333.001.664.053.98.154V9.456c-3.924.092-7.089 3.31-7.089 7.255 0 1.836.696 3.603 1.95 4.944a7.22 7.22 0 004.161 1.316c4.002 0 7.259-3.256 7.259-7.26z","fill":"#000"}})])])
          )
        }
      }
    